import { useState } from 'react'

import { WorkspacePrebidModuleSlice } from 'features/globalSetup/contexts/PrebidModulesContext'
import { useQuery } from 'providers/tanstack-query/useQuery'
import { fromDTO } from './api/mapper'
import { GET_WORKSPACE_PREBID_MODULE } from './api/query'
import { Data, Variables } from './api/types'
import { Props, UseGetWorkspacePrebidModule } from './types'

export const useGetWorkspacePrebidModule = ({ id }: Props): UseGetWorkspacePrebidModule => {
  const [workspacePrebidModule, setWorkspacePrebidModule] = useState<WorkspacePrebidModuleSlice>()

  const { isLoading: loading } = useQuery<Variables, Data>({
    onCompleted: async (data: Data): Promise<void> => {
      const { node: workspacePrebidModule } = data

      if (workspacePrebidModule) {
        setWorkspacePrebidModule(fromDTO(workspacePrebidModule))
      }
    },
    options: { enabled: !!id },
    query: GET_WORKSPACE_PREBID_MODULE,
    variables: { id: id! },
  })

  return { loading, workspacePrebidModule }
}
